import './styles/index.css';
import logoUrl from '@/assets/logo.jpeg';
import { initializeHeader } from './modules/header';
import { initializeTheme } from './modules/theme';
import { initializeIframe } from './modules/iframe';
import { initializeHeaderAuth } from './modules/header-auth';
import { initializeThemeSync } from './modules/theme-sync';
function initializeApp() {
    console.log('Bootstrap starting...');
    // Initialize theme functionality
    initializeTheme();
    console.log('Theme initialized');
    // Initialize header functionality
    initializeHeader();
    console.log('Header initialized');
    // Initialize header auth functionality
    initializeHeaderAuth();
    console.log('Header auth initialized');
    // Initialize iframe functionality first (sets up communication)
    initializeIframe();
    console.log('Iframe initialized');
    // Initialize theme synchronization after iframe is ready
    initializeThemeSync();
    console.log('Theme sync initialized');
    // Inject logo sources
    const headerLogo = document.getElementById('logo-header');
    if (headerLogo)
        headerLogo.src = logoUrl;
    const heroLogo = document.getElementById('logo-hero');
    if (heroLogo)
        heroLogo.src = logoUrl;
    // Set current year in footer
    const yearElement = document.getElementById('year');
    if (yearElement) {
        yearElement.textContent = new Date().getFullYear().toString();
    }
}
// Initialize the app when DOM is loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
}
else {
    initializeApp();
}
